
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class Loader extends Vue {
  @Prop({ default: 'local' }) private loaderType!: string;
  @Prop({ default: 'Loading...' }) private loaderMessage!: string;
  @Prop({ default: false }) private show!: boolean;
}
